import React, { useState } from "react";
import { Modal, CircularProgress } from "@mui/material";
import { useForm, Controller } from "react-hook-form";

const AddWorkDetails = ({ onClose, getData, reverseData }) => {
  const [loading, setLoading] = useState(false);

  const {
    control,
    formState: { errors },
    handleSubmit,
  } = useForm({
    defaultValues: {
      note: reverseData ? reverseData : "",
    },
  });

  const onSubmit = async (data) => {
    getData(data.note);
    setLoading(true);
    if (data) {
      onClose(true);
    }
    setLoading(false);
  };

  return (
    <Modal onClose={() => {}} open={true}>
      <form
        className="upload-dictation-modal"
        onSubmit={handleSubmit(onSubmit)}
      >
        <h1 className="udm-title">Add Work Details</h1>
        <div className="udm-input-div">
          <p
            className="udm-label"
            style={{ fontWeight: "normal", fontSize: "20px" }}
          >
            Work Description
          </p>
          <Controller
            name="note"
            control={control}
            render={({ field }) => (
              <textarea
                rows={5}
                cols={5}
                name="note"
                error={Boolean(errors.note)}
                style={{ width: "50%" }}
                {...field}
              />
            )}
          />
        </div>
        <div className="udm-btn-cont">
          <button type="submit" className="udm-save" style={{ minWidth: 150 }}>
            {loading ? (
              <CircularProgress
                style={{ color: "#fff", width: 16, height: 16 }}
              />
            ) : (
              "Add"
            )}
          </button>
          <button
            className="udm-cancel"
            type="button"
            onClick={() => {
              onClose();
            }}
          >
            Cancel
          </button>
        </div>
      </form>
    </Modal>
  );
};

export default AddWorkDetails;
